import mapList from '../../selectors/lists/mapList'


const GET_TRANSPORTATION_MODE_LIST = 'dofe-bo/LIST/GET_TRANSPORTATION_MODE_LIST'
const GET_TRANSPORTATION_MODE_LIST_SUCCESS = 'dofe-bo/LIST/GET_TRANSPORTATION_MODE_LIST_SUCCESS'
const GET_TRANSPORTATION_MODE_LIST_FAIL = 'dofe-bo/LIST/GET_TRANSPORTATION_MODE_LIST_FAIL'


const initialState = {
  transportationMode: {
    list: [],
    loading: false,
    loaded: false,
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: ''
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TRANSPORTATION_MODE_LIST:
      return {
        ...state,
        transportationMode: {
          loading: true
        }
      }
    case GET_TRANSPORTATION_MODE_LIST_SUCCESS:
      return {
        ...state,
        transportationMode: {
          loading: false,
          loaded: true,
          list: mapList(action.result),
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
        }
      }
    case GET_TRANSPORTATION_MODE_LIST_FAIL:
      return {
        ...state,
        transportationMode: {
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getTransportationModeList() {
  return {
    types: [GET_TRANSPORTATION_MODE_LIST, GET_TRANSPORTATION_MODE_LIST_SUCCESS, GET_TRANSPORTATION_MODE_LIST_FAIL],
    promise: client => client.get('api/transportation-mode/list')
  }
}
